import { forwardRef } from "react";
import type { IconsaxProps } from "./Iconsax.types.js";

export const CheckLinear = forwardRef<HTMLDivElement, IconsaxProps>(({ size = 24, color = "currentColor", ...rest }, ref) => {
    return (
        <div ref={ref} {...rest} style={{ display: "flex", width: "fit-content", alignItems: "center", justifyContent: "center", ...rest.style }}>
            <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M22.7876 4.21073C23.0708 4.49171 23.0708 4.94726 22.7876 5.22824L8.10939 19.7893C7.82616 20.0702 7.36694 20.0702 7.0837 19.7893L1.21243 13.9649C0.929191 13.6839 0.929191 13.2283 1.21243 12.9473C1.49567 12.6664 1.95488 12.6664 2.23812 12.9473L7.59655 18.263L21.7619 4.21073C22.0451 3.92976 22.5043 3.92976 22.7876 4.21073Z"
                    fill={color}
                />
            </svg>
        </div>
    );
});
